import { render, staticRenderFns } from "./CouponManagement.vue?vue&type=template&id=1ae42bfc&scoped=true"
import script from "./CouponManagement.vue?vue&type=script&lang=ts"
export * from "./CouponManagement.vue?vue&type=script&lang=ts"
import style0 from "./CouponManagement.vue?vue&type=style&index=0&id=1ae42bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae42bfc",
  null
  
)

export default component.exports